// extracted by mini-css-extract-plugin
export var icon = "_6w-1";
export var subtext = "_6w-0";